import { useAuth } from "../../../../contexts/auth";
import { services as owners } from "../../../../policy-engine/constants";
import { servicesDictionary } from "../../../../policy-engine/dictionary/services";

function getLeafActions(actionTree, path = []) {
	return Object.entries(actionTree).flatMap(([key, value]) => {
		const currentPath = [...path, key];
		if (value && typeof value === "object") {
			return getLeafActions(value, currentPath);
		}

		const actionPath = currentPath.join(".");
		return [actionPath];
	});
}

function Action({ owner, service, scope, action, ...props }) {
	const { can } = useAuth();

	function getOwners() {
		const keys = Array.from(owners.keys());
		const options = keys.map(key => ({
			key,
			value: servicesDictionary[key]
		}));
		return [
			...options
		];
	}

	function getServices() {
		if (!owner) {
			return [{ key: 0, value: 'Selecione a fonte' }]
		}
		if (owner === '*') {
			return [{ key: '*', value: 'Todos' }]
		}
		const keys = Object.keys(owners.get(owner));
		const options = keys.map(key => ({
			key,
			value: servicesDictionary[`${owner}.${key}`],
		}));
		return [
			{ key: 0, value: 'Nenhum' },
			{ key: '*', value: 'Todos' },
			...options
		];
	}

	function getScopes() {
		if (!owner || !service) {
			return [{ key: 0, value: 'Selecione o serviço' }]
		}
		if (service === '*') {
			return [{ key: '*', value: 'Todos' }]
		}
		const keys = Object.keys(owners.get(owner)[service]);
		const options = keys.map(key => ({
			key,
			value: servicesDictionary[`${owner}.${service}.${key}`]
		}));
		return [
			{ key: 0, value: 'Nenhum' },
			{ key: '*', value: 'Todos' },
			...options
		];
	}

	function getActions() {
		if (!owner || !service || !scope) {
			return [{ key: 0, value: 'Selecione o escopo' }]
		}
		if (scope === '*') {
			return [{ key: '*', value: 'Todos' }]
		}
		const actionTree = owners.get(owner)?.[service]?.[scope];
		if (!actionTree || typeof actionTree !== "object") {
			return [{ key: 0, value: 'Nenhuma ação disponível' }];
		}

		const options = getLeafActions(actionTree).map((key) => ({
			key,
			value: servicesDictionary[`${owner}.${service}.${scope}.${key}`] ?? key,
		})).filter(option => can?.(`${owner}.${service}.${scope}.${option.key}`));

		console.log(getLeafActions(actionTree).map((key) => ({
			key,
			value: servicesDictionary[`${owner}.${service}.${scope}.${key}`] ?? key,
		})));

		const actions = [
			{ key: 0, value: 'Nenhum' },
			{ key: '*', value: 'Todas' },
			...options
		];
		return actions;
	}

	return (
		<div className="action-item">
			<select name="owner" value={owner} onChange={e => props.onUpdateField(e.target.value, 'owner')}>
				{getOwners().map((o, idx) => (
					<option key={idx} value={o.key}>{o.value}</option>
				))}
			</select>
			<select name="service" value={service} onChange={e => props.onUpdateField(e.target.value, 'service')}>
				{getServices().map((s, idx) => (
					<option key={idx} value={s.key}>{s.value}</option>
				))}
			</select>
			<select name="scope" value={scope} onChange={e => props.onUpdateField(e.target.value, 'scope')}>
				{getScopes().map((s, idx) => (
					<option key={idx} value={s.key}>{s.value}</option>
				))}
			</select>
			<select name="action" value={action} onChange={e => props.onUpdateField(e.target.value, 'action')}>
				{getActions().map((a, idx) => (
					<option key={idx} value={a.key}>{a.value}</option>
				))}
			</select>
		</div>
	);
}

export default Action;